import {loadMutationSelectOptions} from "@/helpers/tools/tools-mutation-helper";
import {LoadFilterSelectOptions} from "@/helpers/filter/filter-geometry-helper";

export function reloadGeometryLayers() {
    loadMutationSelectOptions()
    LoadFilterSelectOptions()
}
